export default color => p =>
  p.theme.palette[color]
